import { useParams } from 'react-router-dom';
import { useSupplierByIdQuery } from 'api';
import { useCallback, useState } from 'react';

export const usePricingRules = () => {
  const [updateModalState, setUpdateModalState] = useState<boolean>(false);

  const { id } = useParams() as { id: string };
  const { data = {} } = useSupplierByIdQuery({ id });

  const onUpdateModalStateChange = useCallback(() => setUpdateModalState((prevState) => !prevState), []);

  return {
    pricingRules: data.pricingRules || {},
    updateModalState,
    onUpdateModalStateChange,
  };
};
